import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, NavLink } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import AuthApi from 'apis/Auth';
import {
  setRole,
  setToken,
  setBusinessId,
  setUserId,
  setDashboardMetricObject,
  setContactDetails,
  setConfirmationGracePeriod,
  setConfirmed,
  getBusinessId,
  getRole,
  setPlanSubscriptionStatus,
  setBusinessPlan,
  setUserData,
  clear,
  setSessionTimeOut,
} from 'constants/localStorageManager.js';
import {
  ROUTES,
  insertIdtoUrl,
  TRIAL_SIGNUP_ROUTES,
} from 'constants/Routes.js';
import { USERS } from 'constants/Users.js';
import 'assets/scss/components/landingPageLogin.css';

import Toaster from '../Toaster';
import ModalDisplay from '../ConfirmationModal/Modal/ModalDisplay';

class Login extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      email: '',
      password: '',
    };
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const { email, password } = this.state;

    this.setState({ loading: true });
    AuthApi.login(email, password)
      .then(response => {
        const token = response.headers.authorization;
        setToken(token);
        setSessionTimeOut();
        this.handleRedirect(response.data);
        this.setState({ loading: false });
      })
      .catch(error => {
        this.setState({ loading: false });
        const errMsg =
          (error.response && error.response.data.error) || error.message;
        if (errMsg.includes('confirm')) {
          return this.showConfirmation();
        }
        Toaster.getErrorToaster('exclamation-triangle', errMsg);
        console.log(error);
      });
  };

  handleRedirect = data => {
    const { history } = this.props;
    const {
      id,
      business,
      role,
      plan,
      dashboard,
      confirmation_grace_period,
      confirmed,
      plan_subscription,
    } = data;
    setConfirmationGracePeriod(confirmation_grace_period);
    setConfirmed(confirmed);
    if (!dashboard) {
      if (!confirmed && confirmation_grace_period <= 0) this.showConfirmation();
      else {
        setContactDetails(data);
        history.push(TRIAL_SIGNUP_ROUTES.BUSINESS_DETAILS);
      }
      return;
    }

    setUserData(data);
    setUserId(id);
    setDashboardMetricObject(dashboard);
    setRole(role);
    setConfirmationGracePeriod(confirmation_grace_period);
    setConfirmed(confirmed);
    setPlanSubscriptionStatus(plan_subscription);
    setBusinessPlan(plan);

    if (role !== USERS.ADMIN) setBusinessId(business.id);
    if (!confirmed && confirmation_grace_period <= 0) this.showConfirmation();
    else this.displayDashboard();
  };

  displayDashboard = () => {
    const { history } = this.props;
    this.setState({ displayConfirmation: false });
    const pushUrl =
      getRole() === USERS.ADMIN
        ? ROUTES.DASHBOARD_INDEX
        : insertIdtoUrl(ROUTES.BUSINESS_DASHBOARD_INDEX, getBusinessId());
    history.push(pushUrl);
  };

  showConfirmation = () => {
    this.setState({ displayConfirmation: true });
  };

  handleModalClosed = () => {
    this.setState({ displayConfirmation: false }, clear);
  };

  render() {
    const { loading, displayConfirmation, email } = this.state;
    const loggingIn = loading ? <FontAwesomeIcon icon="spinner" pulse /> : null;

    return (
      <React.Fragment>
        <ModalDisplay
          email={email}
          handleModalClosed={this.handleModalClosed}
          displayConfirmation={displayConfirmation}
          loginScreen
        />
        <form
          className="form-inline landing-login-container col-lg-9 col-md-12 col-sm-12"
          onSubmit={this.handleSubmit}
        >
          <input
            className="form-control mr-sm-2 col-lg-4 col-sm-12 mx-auto"
            id="email"
            name="email"
            placeholder="Email"
            onChange={this.onChange}
          />
          <div className="password-container mr-sm-2 col-lg-4 col-sm-12">
            <input
              className="form-control"
              id="pwd"
              name="password"
              placeholder="Password"
              type="password"
              onChange={this.onChange}
            />
            <NavLink className="forgot-password" to={ROUTES.PASSWORD_RESET}>
              Forgot your password?
            </NavLink>
          </div>
          <button
            className="btn btn-outline-light my-2 my-sm-0 pl-4 pr-4"
            type="submit"
          >
            {loggingIn}Log In
          </button>
        </form>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/components/LandingPage/Login.js